import * as React from 'react'
import { NextSeo } from 'next-seo'

import * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'
import { SITE_URL } from '@ulule/config'

type SeoProps = { userLocale: api.Lang }

export function Seo({ userLocale }: SeoProps): React.ReactElement {
  const seo = {
    description: t('On Ulule, tens of thousands of projects have been funded and continue to grow with you.'),
    image: {
      alt: t('Discover Ulule'),
      url: `${process.env.ASSET_PREFIX}/assets/img/discover/share_image_${userLocale}.jpg`,
    },
    title: t('Discover Ulule'),
  }

  return (
    <NextSeo
      title={seo.title}
      description={seo.description}
      additionalLinkTags={[
        {
          rel: 'icon',
          type: 'image/png',
          sizes: '48x48',
          href: `${SITE_URL}/assets/img/common/favicon-48.png`,
        },
        {
          rel: 'icon',
          type: 'image/png',
          sizes: '32x32',
          href: `${SITE_URL}/assets/img/common/favicon-32.png`,
        },
      ]}
      openGraph={{
        description: seo.description,
        title: seo.title,
        images: [
          {
            alt: seo.image.alt,
            url: seo.image.url,
          },
        ],
        url: 'https://www.ulule.com/pages/discover',
      }}
    />
  )
}
